import './SignUp.css'
import { useTranslation } from "react-i18next"
import { SignUpStep1 } from "components/signUp/SignUpStep1"
import { Header } from 'components/common/header/Header'
import Svgs from 'assets/svgs';
import { useQuery } from 'hooks/useQuery'
import { SignUpStep2 } from 'components/signUp/SignUpStep2'
import { useAtom } from 'jotai'
import { stepAtom } from 'store/signUpStore'
import { SignUpStep3 } from 'components/signUp/SignUpStep3';
import { SignUpStep4 } from 'components/signUp/SignUpStep4';
import { SignUpStep5 } from 'components/signUp/SignUpStep5';

export const SignUp = () => {
    const {t} = useTranslation();
    const { navigate } = useQuery();
    const [step, setStep] = useAtom(stepAtom);

    return (
        <div className="sign-up-wrapper">
            <Header title={t('signUpText')} leftBtn={{img: Svgs.icBack24, func: () => {step > 1 ? setStep(prev => prev -1) : navigate(-1)}}}/>
            {/* Step 1 : 본인인증 필요 내용 고지 */}
            <SignUpStep1 />
            {/* Step 2 : 이름 주민번호 통신사 전화번호 */}
            <SignUpStep2 />
            {/* Step 3 : 인증번호 입력 */}
            <SignUpStep3 />
            {/* Step 4 : 약관 동의 */}
            <SignUpStep4 />
            {/* Step 5 : 이메일 비밀번호 닉네임 */}
            <SignUpStep5 />
        </div>
    )
    
}